function initMaps() {
  const maps = document.querySelectorAll('.map');
  maps.forEach(function(mapElement) {
      const lat = parseFloat(mapElement.getAttribute('data-lat'));
      const lng = parseFloat(mapElement.getAttribute('data-lng'));
      const map = new google.maps.Map(mapElement, {
          center: { lat: lat, lng: lng },
          zoom: 14,
          fullscreenControl: false,
          draggable: false,
          keyboardShortcuts: false,
          mapTypeControl: false,
          disableDefaultUI: true,
          mapId: 'YOUR_MAP_ID'  // Voeg hier je geldige kaart-ID toe
      });

      // Controleer of AdvancedMarkerElement beschikbaar is
      if (google.maps.marker && google.maps.marker.AdvancedMarkerElement) {
          const marker = new google.maps.marker.AdvancedMarkerElement({
              map: map,
              position: { lat: lat, lng: lng },
              title: "Location Marker"
          });

          // Voeg marker toe aan de kaart
          marker.setMap(map);
      } else {
          console.error('AdvancedMarkerElement is not available');
      }
  });
}

// Laad het Google Maps script en initialiseer kaarten
function loadGoogleMaps() {
  const script = document.createElement('script');
  script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBxsuFJxk0vh0Vv9so23ThvUSdftLcfBLA&libraries=marker';
  script.async = true;  // Voeg async attribuut toe
  script.defer = true;  // Voeg defer attribuut toe
  script.onload = initMaps;
  document.head.appendChild(script);
}

// Zorg ervoor dat initMaps wordt aangeroepen wanneer het venster laadt
window.onload = function() {
  if (document.querySelectorAll('.map').length > 0) {
      loadGoogleMaps();
  }
};

// Helper function to add passive event listeners
function addPassiveEventListener(element, event, handler) {
  element.addEventListener(event, handler, { passive: true });
}